import { dataScheme } from "../../color-scheme/builtin/default";

export const colorScheme = {
    default: {
        dataScheme: dataScheme,
        palette: {
            backgroundColor: "#202226",
            borderColor: "#404349",
            shadowColor: "rgba(0,0,0,0.1)",
            hoverBackgroundColor: "#404349",
            sliderRailColor: "#404349",
            sliderHandleColor: "#202226",
            sliderTrackColor: "#4284FF",
            popupBackgroundColor: "#404349",
            primaryFontColor: "#fdfdfd",
            secondaryFontColor: "#bbbdc3",
            tertiaryFontColor: "#888c93",
            axisLabelFontColor: "#888c93",
            disableFontColor: "#55595f",
            axisMarkerFontColor: "#202226",
            axisGridColor: "#404349",
            axisDomainColor: "#4b4f54",
            dataZoomHandleStrokeColor: "#bbbdc3",
            dataZoomChartColor: "#55595F",
            playerControllerColor: "#4284FF",
            scrollBarSliderColor: "rgba(255,255,255,0.3)",
            axisMarkerBackgroundColor: "#fdfdfd",
            markLabelBackgroundColor: "#404349",
            markLineStrokeColor: "#bbbdc3",
            dangerColor: "#eb4b4b",
            warningColor: "#f0bd30",
            successColor: "#14b267",
            infoColor: "#4284ff",
            discreteLegendPagerTextColor: "#BBBDC3",
            discreteLegendPagerHandlerColor: "#BBBDC3",
            discreteLegendPagerHandlerDisableColor: "#55595F"
        }
    }
};
//# sourceMappingURL=color-scheme.js.map
